const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT} from "../../constants";
import render from "../../utilities/render";
import {buildExport,prepareDataToSendController,isEdit,doAjax,pushFilterSessionCacheState,isNew,isDeleteView,isOnlyLookupDataUpdate,retriveCriteriaObjectByOperation} from "../../utilities/filtersutil";
import {releaseOrderLookupFieldDropdown} from "./filter/releaseOrderLookupFieldDropdown.js";
import {actionOptions} from "./filter/actionOptions.js";
const _ = require("underscore");
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";

let actionCellDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html");
let actionCellDropdownItemTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html");
let actionHeaderDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html");
let actionList = actionOptions;

const targetSelector = "#release-order-lookup-outer";
run(targetSelector, ()=>{
	const entryElement = $(targetSelector);
	const dataTableComponentData = entryElement.data("release-order-lookup-data");
	const portletNamespace =  $(targetSelector).data("portlet-namespace");
	const savedViews = entryElement.data("saved-views");
	const filterSearchUrl =  $(targetSelector).data("filter-search-url");
  const saveViewURL  =  $(targetSelector).data("save-view-url");
  const deleteViewURL  =  $(targetSelector).data("delete-view-url");
	const detailURL = $(targetSelector).data("release-order-detail-url");
	const releaseOrderUrl = entryElement.data("release-order-url");
  const shouldCheckCache  =  $(targetSelector).data("should-check-cache");
  const criteriaObjectFromServer  =  $(targetSelector).data("filter-criteria-from-server");

	let submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  let exportModal = new buildExport();
	const exportUrl = $(targetSelector).data("export-url");
  let targetObject = "";

  if(shouldCheckCache) {
    targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer, "like");
  }

  let releaseOrderLookup = new LookupTable({

    target: $("#release-order-lookup-wrapper"),
    minWidthClass: "q-min-width-sm-til-md",
    mobileColumns: [
			{
        data: "ordParOrderNumber",
        title: "VZW Order Number",
				render: createDetailLink
      },
      {
        data: "ordParOrderId",
        title: "SAP Delivery Number"
      },
      {
        data: "ordOrderType",
        title: "Order Type"
      },
      {
        data: "ordStatus",
        title: "Order Status"
      },
      {
        data: "ordPosLocation",
        title: "POS Location Number"
      },
      {
        data: "ordCreatedDate",
        title: "Date Recieved",
        render: formatCreateDate
      }
      
    ],

		tableSearch: true,
    // REQUIRED: search input info
		tableSearchInput: {
      // Not required
      // placeholder: 'Custom Search Text'
      value: targetObject != "" ? targetObject.value[0] : ""
    },
		// REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: targetObject == "" ? "" : targetObject.key,
      columns: releaseOrderLookupFieldDropdown
    },
    // OPTIONAL: Set Saved View Array
    savedViews: savedViews,
    bulkSelect: false,
    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: dataTableComponentData.content,
      // Not required, just to show you can
      columnDefs: [{}],
      // Not required, just to show you can
      order: [[5, 'desc']],
      columns: [
        {
          data: "ordParOrderNumber",
					render: renderActionWrap,
          orderable: false,
					title: "Actions",
          class: "dtc-action-column"
        },
        {
          data: "ordParOrderNumber",
          title: "VZW Order Num",
          class: "dtc-min-width-sm",
					render: createDetailLink
        },
        {
          data: "ordParOrderId",
          title: "SAP Delivery Num",
          class: "dtc-min-width-sm"
        },
        {
          data: "ordPosLocation",
          title: "POS Location",
          class: 'dtc-min-width-sm'
        },
        {
          data: "ordOrderType",
          title: "Order Type",
          class: "dtc-min-width-sm"
        },
				{
          data: "ordConsolidatedCount",
          title: "Consolidated Count",
          class: 'dtc-min-width-sm'
        },
        {
          data: "ordCreatedDate",
          title: "Date Received",
          render: formatCreateDate,
          class: 'dtc-min-width-sm'
        },
				{
          data: "ordStatus",
          title: "Order Status",
          class: 'dtc-min-width-sm'
        }
      ],
		},
    paginationData:dataTableComponentData.page,

		filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Release Orders ",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "releaseOrder"
    },

		onBulkSelectChange: function() {
      const selectedRows = releaseOrderLookup.getBulkSelectedData();
      $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass('disabled');
      } else {
        $(".action-header-btn .base-btn").addClass('disabled');
      }
    },

		onFetch:function() {
			let currentData = releaseOrderLookup.generateData();
			releaseOrderLookup.showLoadingOverlay();
			//Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
			if(isOnlyLookupDataUpdate(currentData)){
				setTimeout(() => {
					doAjax({url: filterSearchUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData,portletNamespace)});
				},SUCCESS_MODAL_TIMEOUT);
			}else if(isNew(currentData)){
				setTimeout(() => {
					doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData,portletNamespace)});
				},SUCCESS_MODAL_TIMEOUT);
			 }else if(isEdit(currentData)){
				setTimeout(() => {
					doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData,portletNamespace)});
				},SUCCESS_MODAL_TIMEOUT);
			 }else if(isDeleteView(currentData)){
				 setTimeout(() => {
					doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData,portletNamespace)});
				 },SUCCESS_MODAL_TIMEOUT);
			 }
		}
  });

	function formateDate(createdDate, type, data) {
		if(createdDate != null && createdDate != ""){
		  var date = moment(createdDate).toDate(); // format yyyy-MM-DD
		  var month = date.getMonth() + 1;
		  var today = new Date();
		  today.setHours(0,0,0,0);
		  date.setHours(0,0,0,0);
		  var oneDay = 24*60*60*1000;
		  var diffDays = Math.round(Math.abs((today.getTime() - date.getTime())/(oneDay)));
		  var friendlyText = "";
		  var datePillHTML  = ""
		  if(diffDays < 100){
		  	friendlyText = diffDays.toString() + ' Days Ago';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  if(diffDays == 0){
		    friendlyText = 'Today';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }else if(diffDays== 1){
		    friendlyText ='Yesterday'
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
		}else{
		  return "";
		}
  }
  
  function formatCreateDate(createdDate, type, data) {
    var d = new Date(createdDate); 
    return  d.toLocaleString();
	}

	function createDetailLink(data, type, row) {
    let detailPageHTML = `<div class="q-marg-all-xs-at-md">
                        <a href="${detailURL}&${portletNamespace}ordId=${row.ordId}&${portletNamespace}masterId=${row.ordMasterId}">
                        ${row.ordParOrderNumber} </a> </div>`;
    return detailPageHTML;
  }

  function formateDate(dateReceived, type, data){
    if(dateReceived != null && dateReceived != "") {
      let date = new Date(dateReceived);
      let month = date.getMonth() + 1;
      let today = new Date();
      let oneDay = 24*60*60*1000;
      today.setHours(0,0,0,0);
      date.setHours(0,0,0,0);
      let diffDays = Math.round(Math.abs((today.getTime() - date.getTime())/(oneDay)));
      let friendlyText = "";
      let datePillHTML  = "" ;
      if(diffDays < 100) {
        friendlyText = diffDays.toString() + ' Days Ago';
        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>";
      }
      if(diffDays == 0) {
        friendlyText = 'Today';
      } else if(diffDays== 1) {
        friendlyText ='Yesterday';
      }
      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
    } else {
      return "";
    }
  }

	function filterSuccessFun(data) {
    let releaseOrders = data.content;
    let page = data.page;
    releaseOrderLookup.setNewData(releaseOrders);
    releaseOrderLookup.setPaginationData(page);
    pushFilterSessionCacheState();
		releaseOrderLookup.hideLoadingOverlay();
    setExportData(releaseOrderLookup.generateData());
  }

  function savedViewSuccess(data) {
    let releaseOrders = data.lookupReleaseOrderJSON.content;
    let page = data.lookupReleaseOrderJSON.page;
    releaseOrderLookup.setNewData(releaseOrders);
    releaseOrderLookup.setPaginationData(page);
    releaseOrderLookup.setNewSavedViewData(data.savedView, "newSavedView");
    pushFilterSessionCacheState();
    releaseOrderLookup.hideLoadingOverlay();
    setExportData(releaseOrderLookup.generateData());
  }

  function savedEditViewSuccess(data) {
    let releaseOrders = data.lookupReleaseOrderJSON.content;
    let page = data.lookupReleaseOrderJSON.page;
    releaseOrderLookup.setNewData(releaseOrders);
    releaseOrderLookup.setPaginationData(page);
    releaseOrderLookup.setNewSavedViewData(data.savedView, data.savedView.target);
    pushFilterSessionCacheState();
    releaseOrderLookup.hideLoadingOverlay();
    setExportData(releaseOrderLookup.generateData());
  }

  function delteViewScussFun(data) {
    let releaseOrders = data.lookupReleaseOrderJSON.content;
    let page = data.lookupReleaseOrderJSON.page;
    releaseOrderLookup.removeSavedView(data.target);
    releaseOrderLookup.setNewData(releaseOrders);
    releaseOrderLookup.setPaginationData(page);
    releaseOrderLookup.hideLoadingOverlay();
    setExportData(releaseOrderLookup.generateData());
  }

  function errorFun(data) {
    releaseOrderLookup.hideLoadingOverlay();
  }

  releaseOrderLookup.init();

	function shallAllowClick(currentObj) {
		return !$(currentObj).hasClass("disabled");
	}

	$("body").on("click", ".release-order", function(e) {
    e.preventDefault();
    if (shallAllowClick(this)) {
      // Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
      let pIndex = $(this)
        .closest(".dropdown-menu")
        .data("parent-index");
      // Get the row based on the parent...
      let parent = $(".dropdown-parent-" + pIndex).parents("tr");
      // Get the row data
      let row = $(".data-table-component")
        .dataTable()
        .api()
        .row(parent);

      if ($(this).hasClass("release-order")) {
        processReleaseOrder(row);
      }
    }
  });

  function processReleaseOrder(row) {
    const submitModal = new SubmitModalFlow({
      confirmModalTitle: "Release Order(s)",
      confirmModalBody: `<div class="q-marg-all-xl">
                          <div class="q-marg-vert-md">
                            Confirming the manual release of this Order(s) will trigger it's original release process.
                          </div>
                          <div class="q-marg-vert-md">
                            Once released, order status will be updated.
                          </div>
                        </div>`,
      confirmModalBtnText: "Release",
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function() {
        submitModal.showLoadingModal();
        let data = row.data();
        releaseOrder(row, data);

        function releaseOrder(row, releaseOrder) {
          $.ajax({
            url: releaseOrderUrl,
            type: "POST",
            dataType: "JSON",
            data: {
              ordId: releaseOrder.ordId,
              masterId: releaseOrder.ordMasterId
            },
            success: function(data) {
              if (data.response === "success") {
                submitModal.showSuccessModal();
                setTimeout(function() {
                  location.reload();
                }, window.constants.SUCCESS_MODAL_TIMEOUT);
              } else {
                submitModal.showFailureModal();
              }
            },
            error: function(data) {
              submitModal.showFailureModal();
            }
          });
        }
      }
    });
    submitModal.init();
    submitModal.showConfirmModal();
  }

	function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionList["actions"];
    newRender = render(actionCellDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row),
      index: meta.row
    });
    return newRender;
  }

  function renderActionHeaderWrap() {
    let statusTarget = actionList["all"];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(actionHeaderDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row)
    });
    return newRender;
  }

	function renderActionCellList(list, data, row) {
    let renderedList = _(list).map(item => {
      return render(
        actionCellDropdownItemTemplate,
        neededActions(data, row, item)
      );
    });
    return renderedList.join("");
  }

	function neededActions(data, row, item) {
    let action = {
      icon: item.icon,
      title: item.title,
      cls: item.cls,
      disabled: item.disabled
    };
    return action;
  }

	function initExport() {
    let exportObj  =  {
      title : $(targetSelector).data("export-popup-title"),
      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
    };
    exportModal.init(exportObj);
    exportModal.bindExportEvent(portletNamespace);
  }

	function setExportData(currentData) {
    exportModal.buildExportBasicURL(exportUrl,currentData,portletNamespace);
    exportModal.setExportCount(currentData.totalElements);
  }

  initExport();
  setExportData(releaseOrderLookup.generateData());

  handleCustomDropdownEvents();

  $("th.dtc-action-column").html(renderActionHeaderWrap());

});



// WEBPACK FOOTER //
// ./src/pages/releaseOrders/lookup.js